// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, Markdown, Paragraph, Heading } from 'grommet'
import PropTypes from 'prop-types'

const MarkdownComponent = ({ data }) => {
  return (
    <Markdown
      data-testid="markdown-component"
      components={{
        p: {
          component: Paragraph,
          props: {
            fill: 'true'
          }
        },
        h1: {
          component: Heading,
          props: { level: '1', margin: { vertical: 'xsmall' } }
        },
        h2: {
          component: Heading,
          props: { level: '2', margin: { vertical: 'xsmall' } }
        },
        h3: {
          component: Heading,
          props: { level: '3', margin: { vertical: 'xsmall' } }
        },
        h4: {
          component: Heading,
          props: { level: '4', margin: { vertical: 'xsmall' } }
        },
        box: {
          component: Box,
          props: { pad: { left: 'medium' }, alignContent: 'start' }
        }
      }}
    >
      {data}
    </Markdown>
  )
}
MarkdownComponent.propTypes = {
  data: PropTypes.string.isRequired
}

export { MarkdownComponent }
